module.exports = __webpack_public_path__ + "SHSADCAA/static/media/notification.b9f27714.svg";